import { ec, ecId, ecLean, handBack, int, record, requiredInt, type JanusCtx, type Row } from '../context.js';
import { lostShapeshift } from '../../port/k4-dispatch/status_removal_api.js';
import { isFormStatus, planFormStatusRemoval } from '../../statuses/shapeshift-inventory.js';
import { npcFormRemovalPlanFailure } from '../../compile/npc-form-removal-plan.js';

/** The damage lanes read the compiled vitality cluster, falling back to the lean persisted column. */
export function temporaryVitality(target: Row): number {
  return requiredInt(record(record(target.computed)?.vitality)?.v_temp ?? ecLean(target, 'v_temp'), 'damage_type_roll:temp-vitality-not-held');
}

/** Decide on held state before drawing; a caller must persist every part of a possible revert. */
export function requireTemporaryVitalityLane(ctx: JanusCtx, target: Row, before: number, mayRevert = true): void {
  if (before < 0) handBack('damage_type_roll:negative-temp-vitality');
  if (before > 0 && int(ctx.read.value(target, 'shapeshifted') ?? 0) === 1) {
    if (ctx.shapeshiftInventory === undefined) handBack('lost_shapeshift:lane-cannot-persist');
    if (!mayRevert) return;
    const form = ctx.read.statuses(target).find(status => isFormStatus(ctx, status));
    if (!form) handBack('lost_shapeshift:form-status-not-held');
    const failure = npcFormRemovalPlanFailure(target, form, ctx.read.definition);
    if (failure) handBack('lost_shapeshift:' + failure);
    const writes = planFormStatusRemoval(ctx, target, form);
    if (ecId(target) !== ctx.shapeshiftActorId && writes.some(write => write.kind === 'unequip_acquired'))
      handBack('lost_shapeshift:lane-cannot-persist');
  }
}

/** apply_damage_to_target: absorb, revert at exact zero, then let the caller apply overflow. */
export function absorbTemporaryVitality(ctx: JanusCtx, target: Row, damage: number, before: number): number {
  requireTemporaryVitalityLane(ctx, target, before, damage >= before);
  if (before <= 0) return damage;
  const remaining = Math.max(0, before - damage);
  ec(target).v_temp = remaining;
  const vitality = record(record(target.computed)?.vitality);
  if (vitality) vitality.v_temp = remaining;
  if (remaining === 0 && int(ctx.read.value(target, 'shapeshifted') ?? 0) === 1) {
    lostShapeshift(ctx, target, 'lost_shapeshift');
  }
  return Math.max(0, damage - before);
}
